import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Translation from '@swf/components/Translation/Translation';
import { ResolverTag } from '@swf/core/enums';

import { TXTCLI_18X_PLAY_RESPONSIBLYX_Xa_hrefX_ELL } from './RegulatoryHeaderPT.messages.json';
import styles from './RegulatoryHeaderPT.scss';

const RegulatoryHeaderPT: React.FC = () => (
  <div className={styles.regulatoryHeader}>
    <Translation
      values={{
        a: (msg: string) => <ResolverLink resolverTag={ResolverTag.SicadPT}>{msg}</ResolverLink>
      }}
      {...TXTCLI_18X_PLAY_RESPONSIBLYX_Xa_hrefX_ELL}
    />
  </div>
);

export default RegulatoryHeaderPT;
